module.exports = __webpack_public_path__ + "static/media/LEMONMILK-Bold.8daf0546.otf";